import { computed, Injectable, signal } from '@angular/core';
import {
  InventoryItem,
  SelectableInventoryItem,
} from '@app/utils/interfaces/inventory-item.interface';
import { OrderSummaryOutcome } from '@app/utils/interfaces/orders.interface';

@Injectable({
  providedIn: 'root',
})
export class ProductsControlService {
  public selectedProducts = signal<SelectableInventoryItem[]>([]);
  public selectedProductIds = signal<string[]>([]);

  public orderProductsPayload = computed(() =>
    this.selectedProducts().map((product) => ({
      inventoryItemId: product.id,
      amount: product.quantity ?? 0,
    })),
  );

  public reset() {
    this.selectedProducts.set([]);
    this.selectedProductIds.set([]);
  }

  public selectProductId(id: string): void {
    this.selectedProductIds.update((i) => [...i, id]);
  }

  public unselectProductId(id: string): void {
    this.selectedProductIds.update((ids) => ids.filter((productId) => productId !== id));
  }

  public selectProducts(item: InventoryItem): void {
    this.selectedProducts.update((i) => [...i, item]);
    const initialQuantity = item.availableAmount ? 1 : 0;
    this.setProductQuantity(item.id, initialQuantity);
  }

  public unselectProducts(id: string): void {
    this.selectedProducts.update((items) => items.filter((existing) => existing.id !== id));
  }

  public handleRemove(id: string): void {
    this.unselectProducts(id);
    this.unselectProductId(id);
  }

  public setProductQuantity(id: string, quantity: number): void {
    this.selectedProducts.update((items) =>
      items.map((item) => {
        return item.id === id ? { ...item, quantity: quantity } : item;
      }),
    );
  }


  public productsTotalNumber(): OrderSummaryOutcome {
    let total = 0;
    let totalCost = 0;
    let totalPromotion = 0;

    this.selectedProducts().forEach((product) => {
      const count = product.quantity ?? 0;
      total += count;

      totalCost += product.price * count;

      if (product.promotionPrice && product.promotionPrice < product.price) {
        const discountAmount = product.price - product.promotionPrice;
        totalPromotion += discountAmount * count;
      }
    });

    return {
      total,
      totalCost,
      totalPromotion,
    };
  }
}
